<div #barsgraph class="barsgraph">
  <!-- <div class="graph_buttons" *ngIf="!selectedItem">
  <div (click)="zoom('out')" class="icon zoomout"></div>
  <div (click)="zoom('in')" class="icon zoomin"></div>

</div> -->
@if (position > 0 && !selectedItem) {
  <div class="graph-controls prev">
    <div (click)="previous()" class="icon"></div>
  </div>
}
@if (position < list?.length - showNumber && !selectedItem) {
  <div class="graph-controls next">
    <div (click)="next()" class="icon"></div>
  </div>
}


<svg width="100%" height="100%" [attr.viewBox]="viewBoxSize">
  <g class="bars" >
    <g class="table">
      @for (line of range; track line; let i = $index; let last = $last) {
        <g >
          <line class="guide" x1="32" [attr.y1]="10 + (separatorIndex * i)" [attr.x2]="viewBoxwidth - 24" [attr.y2]="10 + (separatorIndex * i)"></line>
          <g>
            <text class="guide yAxis" x="30" [attr.y]="15 + (separatorIndex * i)">
              {{i == 0 ? '&#62;' : last ? '&#60;' : ''}}{{ max - ( i * differenceBy) | number:'1.0-1'}}%
            </text>
          </g>
        </g>
      }
      <line class="axys" x1="35" y1="10" x2="35" [attr.y2]="viewBoxheigth - 20" />

      @for (item of list | slice:position:showNumber+position ; track item; let i = $index) {
        <g>
          <line class="guide" [attr.x1]="labelPosition(i)" y1="10" [attr.x2]="labelPosition(i)" [attr.y2]="viewBoxheigth - 17"></line>
          <text class="guide xAxis" [attr.x]="labelPosition(i)" [attr.y]="viewBoxheigth - 8">{{getXLabel(item)}}</text>
          @for (graph of yObjects; track graph; let yOb = $index) {
            <g class="bar">
              <rect
                [attr.width]="getBarWidth()"
                [attr.height]="getBarheight(item, graph)"
                [attr.x]="getBarX(i, yOb)"
                [attr.y]="10 + (this.separatorIndex * this.numberOfParts)"
                [ngClass]="getClasses(item, graph)"
                (click)="openDetailBar(item, graph)"
                />
              <rect />
            </g>
          }
        </g>
      }

      <line class="axys" x1="35" [attr.y1]="viewBoxheigth - 20" [attr.x2]="viewBoxwidth - 24" [attr.y2]="viewBoxheigth - 20" />

    </g>
  </g>
</svg>

@if (selectedItem) {
  <div class="detail-box" [ngClass]="getClasses(selectedItem.item, selectedItem.graph)">
    @if (selectedItem.item.index > 0) {
      <div class="graph-controls prev">
        <div (click)="previousDetail()" class="icon"></div>
      </div>
    }
    @if (selectedItem.item.index < this.list.length - 1) {
      <div class="graph-controls next">
        <div (click)="nextDetail()" class="icon"></div>
      </div>
    }
    <div class="close" (click)="selectedItem = null">X</div>
    <p class="title">{{ _gS.backTranslate(selectedItem.item, 'label_name')}}</p>
    <p class="percentage">{{selectedItem.item.average | number:'1.0-2'}}%</p>
    <p class="value">{{selectedItem.item.executed}}/{{selectedItem.item.projected}}</p>
  </div>
}
</div>
